export enum SvzMediaCarouselRenderMode {
  LIST = 'list',
  ONE_BY_ONE = 'one-by-one',
}
